"use client";
import React from "react";
import classNames from "classnames";
import Link from "next/link";
import { toPairs } from "ramda";
import { encode } from "app/(jobs-hiring)/[lang]/jobs-hiring-old/interpreters/encoder";
import ViewMore from "./ViewMore.mobile";
import AnalyticsLink from "./AnalyticsLink";

import styles from "./SimilarJobs.mobile.module.scss";
import { setJobViewCookiesTracker, viewJobSourceTracker } from "components/ReportTracker/util";
import { setCookie } from "helpers/cookies";

type propsType = {
  data: any;
  lang: string;
  sessionid: string | undefined;
};

export default function SimilarJobs({ lang, data, sessionid }: propsType) {
  const list = data?.similar_job_info ?? [];
  if (list?.length) {
    return (
      <div className={styles.similarJobs}>
        <div className={styles.caption}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='102'
            height='6'
            viewBox='0 0 102 6'
            fill='none'
          >
            <path
              d='M101.887 3L99 0.113249L96.1133 3L99 5.88675L101.887 3ZM0 3.5H99V2.5H0V3.5Z'
              fill='url(#paint0_linear_5818_49794)'
            />
            <defs>
              <linearGradient
                id='paint0_linear_5818_49794'
                x1='0'
                y1='3.5'
                x2='99'
                y2='3.5'
                gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#E4E4E4' stopOpacity='0.4' />
                <stop offset='1' stopColor='#E4E4E4' />
              </linearGradient>
            </defs>
          </svg>
          <h3>{data.title}</h3>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='102'
            height='6'
            viewBox='0 0 102 6'
            fill='none'
          >
            <path
              d='M0.113249 3L3 5.88675L5.88675 3L3 0.113249L0.113249 3ZM3 3.5H102V2.5H3V3.5Z'
              fill='url(#paint0_linear_5818_49796)'
            />
            <defs>
              <linearGradient
                id='paint0_linear_5818_49796'
                x1='3'
                y1='3.5'
                x2='102'
                y2='3.5'
                gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#E4E4E4' />
                <stop offset='1' stopColor='#E4E4E4' stopOpacity='0.4' />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className={styles.list}>
          <ul>
            {list.map((item) => {
              return (
                <AnalyticsLink key={item.job_id} href={null} data={item}>
                  <a
                    href={"/" + lang + item.job_url}
                    target='_blank'
                    onClick={(e) => {
                      e.preventDefault();
                      setJobViewCookiesTracker(setCookie, {
                        source: viewJobSourceTracker.similarJobList,
                        reco_from: item?.reco_from || null,
                        query_id: item?.query_id || null
                      });
                      window.open("/" + lang + item.job_url, "_blank");
                    }}
                  >
                    <li>
                      <h4>
                        {item.job_title}
                        {item.is_urgent ? (
                          <span className={styles.urgent}>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='12'
                              height='12'
                              viewBox='0 0 12 12'
                              fill='none'
                              className={styles.svg}
                            >
                              <path
                                d='M8.56256 1.50055H4.95552C4.78785 1.50055 4.6359 1.5993 4.5678 1.75252L2.33392 6.77874C2.20922 7.05932 2.4146 7.37536 2.72164 7.37536H5.00616L3.8896 11.2833C3.84091 11.4537 4.05318 11.5753 4.17555 11.4471L9.86994 5.48159C10.1277 5.21158 9.93629 4.76433 9.56303 4.76433H7.61719L8.94206 2.11459C9.08312 1.83248 8.87797 1.50055 8.56256 1.50055Z'
                                fill='black'
                              />
                            </svg>
                            {item.urgent_text}
                          </span>
                        ) : null}
                      </h4>
                      <div className={styles.title}>
                        <p>
                          <span className={styles.text}>{item.job_title}</span>
                        </p>
                      </div>
                      <p className={styles.salary}>
                        <span>
                          {item.salary_info.text}
                          {item.salary_info.type_text ? (
                            <span className={styles.salaryType}>
                              [{item.salary_info.type_text}]
                            </span>
                          ) : null}
                        </span>
                      </p>
                      <p className={styles.company}>
                        {/* <img src={item.company_logo} alt='' /> */}
                        <span>{item.company_name}</span>
                      </p>

                      <div className={styles.jobTag}>
                        <p className={styles.jobTagContent}>
                          {item.location ? (
                            <>
                              <span>{item.location}</span>
                            </>
                          ) : null}
                          {item.job_tags.map((item, idx, list) => {
                            if (idx === list.length - 1) {
                              return <span>{item}</span>;
                            }
                            return (
                              <>
                                <span>{item}</span>
                              </>
                            );
                          })}
                        </p>
                      </div>
                      <div className={styles.recruiter}>
                        <div className={styles.avatar}>
                          {!item.is_online ? <span className={styles.circle}></span> : null}
                          <img
                            width='24'
                            height='24'
                            src={item.recruiter.avatar}
                            alt={item.full_name}
                          />
                        </div>

                        <p>
                          <span>{item.recruiter.full_name}</span>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='3'
                            height='4'
                            viewBox='0 0 3 4'
                            fill='none'
                          >
                            <circle cx='1.5' cy='2' r='1.5' fill='#ACAEB1' />
                          </svg>
                          <span className={styles.jobTitle}>{item.recruiter.job_title}</span>
                        </p>
                      </div>

                      {/* <div className={styles.recruiter}>
                        <div className={styles.avatar}>
                          <span
                            className={classNames({
                              [styles.cover]: true,
                              [styles.online]: item.is_online
                            })}
                          ></span>
                          {item.is_online ? <span className={styles.circle}></span> : null}
                          <img
                            width='24'
                            height='24'
                            src={item.recruiter.avatar}
                            alt={item.full_name}
                          />
                        </div>

                        <p>
                          <span>{item.recruiter.full_name}</span>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='2'
                            height='2'
                            viewBox='0 0 2 2'
                            fill='none'
                          >
                            <circle cx='0.75' cy='1' r='0.75' fill='#7D7D7D' />
                          </svg>
                          <span className={styles.jobTitle}>{item.recruiter.job_title}</span>
                        </p>
                      </div> */}

                      {/* <div className={styles.right}>
                      <p className={styles.salary}>
                        <span>
                          {item.salary_info.text}
                          <span className={styles.salaryType}>[{item.salary_info.type_text}]</span>
                        </span>
                      </p>
                      <div className={styles.recruiter}>
                        <img
                          width='24'
                          height='24'
                          src={item.recruiter.avatar}
                          alt={item.full_name}
                        />
                        <p>
                          <span>{item.recruiter.full_name}</span>
                          <span className={styles.jobTitle}>{item.recruiter.job_title}</span>
                        </p>
                      </div>
                    </div> */}
                    </li>
                  </a>
                </AnalyticsLink>
              );
            })}
          </ul>
        </div>
        {/* <p className={styles.pubDate}>{data.publishedAt}</p> */}

        <ViewMore data={data} sessionid={sessionid} />
      </div>
    );
  }
  return null;
}
